"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgPuzzle = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { d: 'M14.5 12.218c0-1.572-1.5-2-1.5-2v-3h2.226s.537 1.571 2.15 1.571 2.151-1.571 2.151-1.571H21a1 1 0 011 1v7a1 1 0 01-1 1h-1.473s-.538 1.571-2.15 1.571c-1.613 0-2.151-1.571-2.151-1.571H13v-2s1.5-.429 1.5-2zM2 15.218v-7a1 1 0 011-1h1s.5-1.5 2-1.5 2 1.5 2 1.5h2v2.994s1.5.404 1.5 2.006c0 1.602-1.5 2-1.5 2v2H8s-.5-1.5-2-1.5-2 1.5-2 1.5H3a1 1 0 01-1-1z' }))); };
exports.default = SvgPuzzle;
//# sourceMappingURL=Puzzle.js.map